import EmailCondition from 'cio/app-models/conditions/email';
import refinement from './refinement';

export default function (obj: EmailCondition) {
  let { email, eventType, inverse, isVariation, specificLink, linkHref } = obj;
  let { times, within } = refinement(obj);
  let requiresLinkFilter = eventType === 'clicked_email' && specificLink;
  let name = email;
  let filters = {};

  if (email.includes('any_')) {
    name = name.replace('any_', '');
  }

  if (isVariation) {
    // Newsletter variations will have a name with the structure:
    // newsletter_$newsletterId_variation_$templateId
    let [parentType, newsletterId, templateId] = name.split('_').filter((seg) => seg !== 'variation');
    let variationFilter = serializeVariation(templateId);

    // the name still needs to only reference the newsletter ID when sent to the server
    name = `${parentType}_${newsletterId}`;

    if (requiresLinkFilter) {
      filters = {
        and: [variationFilter, serializeSpecificLink(linkHref as string)],
      };
    } else {
      filters = variationFilter;
    }
  } else if (requiresLinkFilter) {
    filters = serializeSpecificLink(linkHref as string);
  }

  let serialized = {
    event: {
      name,
      filters,
      type: eventType,
    },
    times,
    within,
    inverse,
  };

  return serialized;
}

function serializeVariation(templateId: string) {
  return {
    field: 'template_id',
    operator: 'eq',
    value: templateId,
    inverse: false,
  };
}

function serializeSpecificLink(linkHref: string) {
  return {
    field: 'href',
    operator: 'contains',
    value: linkHref,
    inverse: false,
  };
}
